import React from "react";
import { Backdrop, CircularProgress, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { createTheme } from "@mui/material/styles";

const theme = createTheme();

const useStyles = makeStyles(() => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    padding: "0 16px",
  },
  message: {
    marginTop: "20px",
    maxWidth: "90vw",
    wordBreak: "break-word",
  },
}));

export default function SimpleBackdrop({ message }) {
  const classes = useStyles();

  return (
    <Backdrop className={classes.backdrop} open={true}>
      <CircularProgress color="inherit" />
      {message && (
        <Typography variant="h6" className={classes.message}>
          {message}
        </Typography>
      )}
    </Backdrop>
  );
}
